export const messages = {
  en: {
    oweFeeCallable: {
      search: {
        title: 'Search Conditions',
        ownerName: 'Owner Name',
        ownerNamePlaceholder: 'Please enter owner name',
        feeName: 'Fee Name',
        feeNamePlaceholder: 'Please enter fee name',
        callableWay: 'Callable Way',
        callableWayPlaceholder: 'Please select callable way',
        staffName: 'Staff Name',
        staffNamePlaceholder: 'Please enter staff name',
        state: 'State',
        statePlaceholder: 'Please select state'
      },
      list: {
        title: 'Call Records',
        register: 'Register',
        call: 'Call'
      },
      table: {
        id: 'ID',
        ownerName: 'Owner Name',
        payerObjName: 'Payer Object',
        feeName: 'Fee Name',
        amountdOwed: 'Amount Owed',
        timeRange: 'Time Range',
        callableWayName: 'Callable Way',
        staffName: 'Staff Name',
        stateName: 'State',
        remark: 'Remark',
        createTime: 'Create Time'
      },
      write: {
        title: 'Call Registration',
        roomName: 'Room',
        feeName: 'Call Fees',
        remark: 'Remark',
        remarkPlaceholder: 'Please enter remark',
        success: 'Registration successful',
        error: 'Registration failed'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this call record?',
        success: 'Delete successful',
        error: 'Delete failed'
      },
      fetchError: 'Failed to fetch data',
      selectRoomFirst: 'Please select a room first'
    }
  },
  zh: {
    oweFeeCallable: {
      search: {
        title: '查询条件',
        ownerName: '业主名称',
        ownerNamePlaceholder: '请输入业主名称',
        feeName: '费用名称',
        feeNamePlaceholder: '请输入费用名称',
        callableWay: '催缴方式',
        callableWayPlaceholder: '请选择催缴方式',
        staffName: '催缴人',
        staffNamePlaceholder: '请输入催缴人',
        state: '状态',
        statePlaceholder: '请选择状态'
      },
      list: {
        title: '催缴记录',
        register: '登记',
        call: '催缴'
      },
      table: {
        id: '编号',
        ownerName: '业主名称',
        payerObjName: '付费对象',
        feeName: '费用名称',
        amountdOwed: '催缴金额',
        timeRange: '欠费时间段',
        callableWayName: '催缴方式',
        staffName: '催缴人',
        stateName: '状态',
        remark: '说明',
        createTime: '创建时间'
      },
      write: {
        title: '催缴登记',
        roomName: '登记房屋',
        feeName: '催缴费用',
        remark: '催缴说明',
        remarkPlaceholder: '请输入备注',
        success: '登记成功',
        error: '登记失败'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除欠费催缴记录吗？',
        success: '删除成功',
        error: '删除失败'
      },
      fetchError: '获取数据失败',
      selectRoomFirst: '请先选择房屋'
}
  },
  'zh-TW': {
    oweFeeCallable: {
      search: {
        title: '查詢條件',
        ownerName: '業主名稱',
        ownerNamePlaceholder: '請輸入業主名稱',
        feeName: '費用名稱',
        feeNamePlaceholder: '請輸入費用名稱',
        callableWay: '催繳方式',
        callableWayPlaceholder: '請選擇催繳方式',
        staffName: '催繳人',
        staffNamePlaceholder: '請輸入催繳人',
        state: '狀態',
        statePlaceholder: '請選擇狀態'
      },
      list: {
        title: '催繳記錄',
        register: '登記',
        call: '催繳'
      },
      table: {
        id: '編號',
        ownerName: '業主名稱',
        payerObjName: '付費對象',
        feeName: '費用名稱',
        amountdOwed: '催繳金額',
        timeRange: '欠費時間段',
        callableWayName: '催繳方式',
        staffName: '催繳人',
        stateName: '狀態',
        remark: '說明',
        createTime: '創建時間'
      },
      write: {
        title: '催繳登記',
        roomName: '登記房屋',
        feeName: '催繳費用',
        remark: '催繳說明',
        remarkPlaceholder: '請輸入備註',
        success: '登記成功',
        error: '登記失敗'
      },
      delete: {
        title: '刪除確認',
        confirm: '確定刪除欠費催繳記錄嗎？',
        success: '刪除成功',
        error: '刪除失敗'
      },
      fetchError: '獲取數據失敗',
      selectRoomFirst: '請先選擇房屋'
    }
  }
}